// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@hardwoods/XDL/types";
import TooltipPropsDefault from "@insite/mobius/Tooltip/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...TooltipPropsDefault,
        cssOverrides: {
            tooltipContainer: css`
                margin: 0 5px;
            `,
        },
        typographyProps: {
            size: 14,
            color: "text.main",
            lineHeight: "18px",
            css: css`
                display: block;
            `,
        },
    },
} as xBaseTheme["tooltip"];
